
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
  <g clip-path="url(#clip0_3112_31660)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.10048 16.6697H16.5033C16.6488 16.6732 16.7935 16.6472 16.9287 16.5931C17.0638 16.5391 17.1866 16.4582 17.2896 16.3554C17.3926 16.2525 17.4736 16.1298 17.5278 15.9947C17.582 15.8597 17.6083 15.715 17.605 15.5695V4.93421C17.6083 4.78883 17.5821 4.64428 17.528 4.5093C17.4738 4.37432 17.3929 4.25172 17.2901 4.14889C17.1873 4.04606 17.0646 3.96514 16.9297 3.91102C16.7947 3.8569 16.6501 3.8307 16.5048 3.83401H9.24343C9.09927 3.8342 8.95657 3.80503 8.82404 3.74829C8.69151 3.69154 8.57192 3.60841 8.47256 3.50395L7.29901 2.33041C7.2019 2.22308 7.08273 2.13802 6.94968 2.08105C6.81662 2.02408 6.67282 1.99655 6.52814 2.00034H1.10048C0.955093 1.99704 0.810546 2.02323 0.675567 2.07735C0.540589 2.13147 0.417982 2.21239 0.315152 2.31522C0.212322 2.41805 0.131404 2.54066 0.0772848 2.67563C0.0231659 2.81061 -0.00303034 2.95516 0.000278597 3.10055V15.5695C-0.00303034 15.7149 0.0231659 15.8594 0.0772848 15.9944C0.131404 16.1294 0.212322 16.252 0.315152 16.3548C0.417982 16.4576 0.540589 16.5386 0.675567 16.5927C0.810546 16.6468 0.955093 16.673 1.10048 16.6697ZM7.99989 9.51874L8 6.5L9.93301 6.5L9.9329 9.51874L12.4852 9.51873V11.4517H9.9329L9.93299 14.5L7.99998 14.5L7.99989 11.4517H5.44762V9.51874H7.99989Z"/>
  </g>
  <defs>
    <clipPath id="clip0_3112_31660">
      <rect width="18" height="18"/>
    </clipPath>
  </defs>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'AddToList',
    }) as DefineComponent
    </script>
    